import React from 'react'
import { SideBarItemProps } from './iSideBar'
import WebUI from '@utils/UpdatePrefixs'

const SideBarItem: React.FC<SideBarItemProps> = () => {
    return null
}

export default WebUI({ })(SideBarItem)